import { useEffect, useRef } from 'react';
import type { FlatList } from 'react-native';

type UseScrollFilterWhenClickChipProps = {
  targetIndex: number | undefined;
  listRef: React.RefObject<FlatList | null>;
};

/**
 * - 아토믹에서 FILTER_LIST의 칩을 클릭한 후 바텀시트가 열리면서 클릭한 칩이 바텀시트의 맨 위에 오게하는 훅
 */
export const useScrollFilterWhenClickChip = ({
  targetIndex,
  listRef,
}: UseScrollFilterWhenClickChipProps) => {
  // 바텀시트가 열려있는 동안에는 한번 실행 후 다시 실행되면 안되기 때문에 해당 ref가 필요하다.
  const isInitialScrolled = useRef(false);

  useEffect(() => {
    if (
      targetIndex === undefined ||
      !listRef.current ||
      isInitialScrolled.current
    ) {
      return;
    }

    setTimeout(() => {
      listRef.current?.scrollToIndex({
        index: targetIndex,
        animated: true,
      });
    }, 300);

    isInitialScrolled.current = true;
  }, [listRef, targetIndex]);
};
